/* unplugin-vue-components disabled */import { render } from "./FapiaoFAQ.vue?vue&type=template&id=23ccf28e"
import script from "./FapiaoFAQ.vue?vue&type=script&lang=js"
export * from "./FapiaoFAQ.vue?vue&type=script&lang=js"

import "./FapiaoFAQ.vue?vue&type=style&index=0&id=23ccf28e&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/disney-mobile-ui-production-environment/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__